@if (isOpen) {
  <div
    #tooltipWrapper
    class="tooltip-wrapper"
    [@tooltipAnimation]="animation"
    (@tooltipAnimation.start)="animationStart($event)"
    (@tooltipAnimation.done)="animationDone($event)"
    [ngClass]="tooltipType"
    >
    @if (hasContent) {
      <div
        #tooltip
        class="tooltip"
        [style.visibility]="visible"
        [style.pointerEvents]="source !== 'click' ? 'none' : null"
        [ngClass]="[
         typeClass(),
         advStyle().classic.theme,
         advStyle().sidebar ? 'sidebar-' + advStyle().sidebar.position : '',
          positionSet ? '' : 'loading'
        ]"
        >
        <div class="tip" [ngStyle]="advStyle().background" [style.color]="advStyle().background.backgroundColor"></div>

        <div #tooltipContent class="content" [ngStyle]="typeStyle()" [style.pointerEvents]="source !== 'click' ? 'none' : null">
          <!-- <div class="tooltip-body flex-col" resizeObserver (resize)="resized($event)"> -->
          <div class="tooltip-body flex-col">
            <!-- actual content  [@fadeInAnimation]-->
            @for (item of context; let last = $last; track $index) {
              @if (content && item && doneAnimating && !showDefaultTooltip) {
                <div
                  #advancedTooltipWysiwigDiv
                  class="content-container"
                  [deltaContent]="advancedTooltip().content"
                  [renderData]="renderData"
                  [preFilterData]="preFilterData"
                  [ngStyle]="advStyle().font | responsiveStyle"
                  [item]="item"
                  [content]="content"
                  [displayScale]="displayScale"
                  [advancedTooltip]="advancedTooltip"
                  [tooltipContainer]="tooltipContent"
                  [wyswigDiv]="advancedTooltipWysiwigDiv"
                  (contentSet)="tooltipContentReady()"
                  style="line-height: initial !important"
                  resizeObserver
                  (resize)="resized($event)"
                ></div>

                @if (!last) {
                  <hr class="m-1" />
                }
              }
            }

            <!-- actual content default tooltip -->
            @if (content && context && doneAnimating && showDefaultTooltip && defaultTooltip) {
              <div class="content-container defaultTooltipcontent">
                <div class="default-tooltip-body flex-col w-full" resizeObserver (resize)="resized($event)">
                  <div class="header bigger" [ngStyle]="defaultTooltip.titleStyle | responsiveStyle">{{ name }}</div>
                  <div class="main" [ngClass]="{ 'additional-fields': defaultTooltip.fields.length }">
                    <div class="label" [ngStyle]="defaultTooltip.valueStyle | responsiveStyle">
                      <span>{{ defaultTooltip.value.label }}</span>
                    </div>
                    <div class="value small" [ngStyle]="defaultTooltip.valueStyle | responsiveStyle">
                      @if (value !== null && valueFormat) {
                        <span class="small quiet"> {{ valueFormat.prefix }} </span>
                        <span>{{ value | format: valueFormat : false }}</span>
                        <span class="small quiet"> {{ valueFormat.suffix }} </span>
                      }
                      @if (value !== null && !valueFormat) {
                        <span>{{ value }}</span>
                      }
                      @if (value === null) {
                        <span>{{ content.typeSpecific.noDataMessages.inline }}</span>
                      }
                    </div>
                  </div>
                  @for (field of defaultTooltip.fields; track field) {
                    <div class="additional" [ngStyle]="defaultTooltip.contentStyle | responsiveStyle">
                      @if (getItemValue(field) && field.label) {
                        <span class="label">{{ field.label }}</span>
                      }
                      @if (getItemValue(field)) {
                        <span class="value">
                          @if (getFieldFormat(field).prefix) {
                            <span class="unit prefix">{{ getFieldFormat(field).prefix }}</span>
                          }
                          @if (getFieldType(field.field)) {
                            {{ getItemValue(field) | format: getFieldFormat(field) : false }}
                          }
                          @if (getFieldFormat(field).suffix) {
                            <span class="unit suffix">{{ getFieldFormat(field).suffix }}</span>
                          }
                        </span>
                      }
                    </div>
                  }
                  <div class="flex-col right"></div>
                </div>
              </div>
            }
            <!-- end actual content default tooltip -->
          </div>

          @if (source === 'click' && advStyle().closeButton) {
            <div
              #closeButton
              tabindex="3"
              class="close cursor-pointer"
              [ngClass]="closeButtonClasses"
              (mouseenter)="hoverCloseButton = true"
              (mouseleave)="hoverCloseButton = false"
              (click)="hoverCloseButton = false; handleClose()"
              (keyup.enter)="hoverCloseButton = false; handleClose()"
              >
              <button
                class="closer center"
                [ngStyle]="!hoverCloseButton ? closeButtonStyle : closeButtonHoverStyle"
                [ngClass]="{
                  'icon-only':
                    (!hoverCloseButton && !advStyle().closeButton.text) || (hoverCloseButton && !advStyle().closeButton.hoverStyle.text)
                }"
                >
                <i class="icon-{{ !hoverCloseButton ? advStyle().closeButton.icon : advStyle().closeButton.hoverStyle.icon }}"></i>

                @if (advStyle().closeButton.text && !hoverCloseButton) {
                  <span class="shrink-0">
                    {{advStyle().closeButton.text }}
                  </span>
                }

                @if (advStyle().closeButton.hoverStyle.text && hoverCloseButton) {
                  <span class="shrink-0">
                    {{ advStyle().closeButton.hoverStyle.text }}
                  </span>
                }
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
